<template>
    <div class="tooltip-container" @mouseenter="showTooltip" @mouseleave="hideTooltip">
        <slot></slot>
        <div v-if="visible" class="tooltip" :class="position" ref="tooltipRef">
            {{ text }}
        </div>
    </div>
</template>

<script>
import { ref, toRefs } from 'vue';

export default {

    props: {
        text: {
            type: String,
            required: true
        },
        position: {
            type: String,
            default: 'top' // Can be 'top', 'bottom', 'left', or 'right'
        }
    },
    setup(props) {
        const { text, position } = toRefs(props)
        const visible = ref(false);
        const tooltipRef = ref(null);

        const showTooltip = () => {
            visible.value = true;
            adjustTooltipPosition();
        };

        const hideTooltip = () => {
            visible.value = false;
        };

        const adjustTooltipPosition = () => {
            const tooltipEl = tooltipRef.value;
            if (tooltipEl) {
                tooltipEl.style.transform = {
                    top: 'translate(-50%, -100%)',
                    bottom: 'translate(-50%, 0)',
                    'inset-inline-start': 'translate(-100%, -50%)',
                    'inset-inline-end': 'translate(0, -50%)'
                }[position];
            }
        };

        return {
            visible,
            tooltipRef,
            showTooltip,
            hideTooltip
        };
    }
};
</script>

<style scoped>
.tooltip-container {
    display: inline-block;
    position: relative;
}

.tooltip {
    position: absolute;
    background-color: #333;
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
    transition: opacity 0.3s;
    opacity: 0;
}

.tooltip.top {
    bottom: 100%;
    inset-inline-start: 0%;
}

.tooltip.bottom {
    top: 100%;
    inset-inline-start: 50%;
}

.tooltip.left {
    inset-inline-end: 100%;
    top: 50%;

}

.tooltip.right {
    inset-inline-start: 100%;
    top: 50%;
}

.tooltip-container:hover .tooltip {
    opacity: 1;
}
</style>
